import { CloseIcon } from '@any-ui-react/core';
import { tv, VariantProps } from 'tailwind-variants';

const tagStyles = tv({
  slots: {
    root: 'text-gray-9 group flex h-full max-w-max items-center',
    button:
      'hover:bg-gray-2 ml-1 flex h-5 w-5 shrink-0 cursor-pointer items-center justify-center rounded-r',
    buttonWrapper: 'bg-gray-1 flex min-w-0 flex-1 items-center rounded leading-none',
    text: 'min-w-0 flex-1 truncate py-1 pl-2',
  },
  variants: {
    size: {
      md: {
        text: 'text-sm',
      },
      sm: {
        text: 'text-2xs',
      },
      xs: {
        text: 'text-4xs',
      },
    },
    type: {
      anychat: {
        button: 'ml-0 hover:bg-[#BDE5EE]',
        buttonWrapper: 'bg-[#DEF2F6]',
      },
      anytag: {
        button: 'ml-0 hover:bg-[#F3B9B7]',
        buttonWrapper: 'bg-[#FBE5E4]',
      },
      default: {},
    },
    removable: {
      true: {
        text: 'pr-1.5',
      },
      false: {
        text: 'px-2',
        buttonWrapper: 'hover:bg-gray-2',
      },
    },
  },
  compoundVariants: [
    {
      type: 'anychat',
      removable: false,
      class: {
        buttonWrapper: 'bg-[#DEF2F6] hover:bg-[#BDE5EE]',
      },
    },
    {
      type: 'anytag',
      removable: false,
      class: {
        buttonWrapper: 'bg-[#FBE5E4] hover:bg-[#F3B9B7]',
      },
    },
  ],
  defaultVariants: {
    type: 'default',
    size: 'md',
  },
});

export type TagType = VariantProps<typeof tagStyles>['type'];
export type TagSize = VariantProps<typeof tagStyles>['size'];

export const Tag = ({
  id,
  className,
  classNames,
  label,
  count,
  hideCount,
  onRemove,
  size,
  type,
  disabled,
}: {
  id?: string;
  className?: string;
  classNames?: Partial<Record<keyof ReturnType<typeof tagStyles>, string>>;
  type?: TagType;
  label: string;
  count?: number;
  hideCount?: boolean;
  onRemove?: (id?: string) => void;
  size?: TagSize;
  disabled?: boolean;
}) => {
  const { root, button, buttonWrapper, text } = tagStyles({ size, type, removable: !!onRemove });

  return (
    <div className={root({ class: className })}>
      <div className={buttonWrapper({ class: classNames?.buttonWrapper })}>
        <span className={text({ class: classNames?.text })}>{label}</span>

        {onRemove && !disabled && (
          <button
            className={button({ class: classNames?.button })}
            type="button"
            onMouseDown={(e) => {
              e.preventDefault();
              e.stopPropagation();
            }}
            onClick={() => onRemove?.(id)}
          >
            <CloseIcon />
          </button>
        )}
      </div>
      {!hideCount && count !== undefined && <span className="ml-1 shrink-0">({count})</span>}
    </div>
  );
};
